import Image from "_c/Image";
import cls from "./styles.module.css";

type TProps = {
  thumbnail: {
    url: string;
    width?: number;
    height?: number;
    altText?: string;
  };
  postId: number;
};
export default function PostThumb({ thumbnail }: TProps) {
  return (
    <div className={cls.root}>
      <Image
        width={thumbnail.width}
        height={thumbnail.height}
        src={thumbnail.url}
        altText={thumbnail.altText}
      />
    </div>
  );
}
